module.exports = __webpack_public_path__ + "static/media/camera.aeffbd37.svg";